import { Loading } from '../loading';

import './suspense-loading.scss';

export const SuspenseLoading = () => (
  <div className="suspense-loading">
    <Loading />
  </div>
);
